import React, { useContext } from "react";
import { Button } from "react-bootstrap";
import { myContext } from "../../../App";

const FooterC = () => {
  const [whiteColor, setWhiteColor] = useContext(myContext);
  return (
    <>
      <footer className="py-3 text-center">
        {whiteColor ? (
          <Button onClick={() => setWhiteColor(!whiteColor)} variant="dark">
            Dark
          </Button>
        ) : (
          <Button onClick={() => setWhiteColor(!whiteColor)} variant="light">
            Light
          </Button>
        )}
        <p className="">
          Copyright{" "}
          <a target="_blank" href="https://www.linkedin.com/in/abuhorain">
            abuhorain
          </a>{" "}
          || All rights reserved{" "}
        </p>
      </footer>
    </>
  );
};

export default FooterC;
